import script from "./theme-light.vue?vue&type=script&setup=true&lang=js"
export * from "./theme-light.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__